<template>
  <div class="diff-container" translate="no">
    <span v-for="({text, className}, i) in diff" :key="i" :class="'diff-chunk page_title ' + className + (isLines ? ' d-block' : '')">{{text}}</span>
  </div>
</template>
<style scoped>
 .diff-container {
  display: inline-block;
} 
 .diff-chunk {
  color: #666;
}
.delete, .insert {
  color: #000;
}
.insert {
  background-color: #e5ffec;
}
.delete {
  background-color: #ffeef0;
}
</style>
<script>
import {diffWords, diffLines} from 'diff';

export default {
  name: 'Diff',
  props: ['old', 'new', 'oneLine'],
  data() {
    return {
      diffLines: false
    }
  },
  computed: {
    isLines() {
      return this.words.filter(e => e.added || e.removed).length > 3
    },
    words() {
      return diffWords(this.old, this.new)
    },
    diff() {
      let chunks = this.isLines ? diffLines(this.old, this.new) : this.words
      return chunks.map(e => ({
        text: e.value,
        className: e.added ? 'insert' : e.removed ? 'delete' : ''
      }))
    },
  },
}
</script>
